module.exports = __webpack_public_path__ + "img/excel_export.2c73659b.svg";